import { render, staticRenderFns } from "./SousCibleDetails.vue?vue&type=template&id=101307c2&scoped=true&"
import script from "./SousCibleDetails.vue?vue&type=script&lang=js&"
export * from "./SousCibleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101307c2",
  null
  
)

export default component.exports